import React, { useState } from 'react'
import AddNewFamilyHealthHistory from './AddNewFamilyHealthHistory';

const FamilyHealthHistory = ({ expandAll, data, setIsRecordSaved,  patientID, ...props  }) => {
  let { isViewAllowed, IsEditAllowed , IsDeleteAllowed} = props;

  const [isOpenFamilyHealthHistory, setIsOpenFamilyHealthHistory] = useState(false);
  const [familyHealthHistoryData, setFamilyHealthHistoryData] = useState([]);
  const [expandItems, setExpandItems] = useState(true);

  const handleToggleExpand = () => {
    setExpandItems(prev => !prev);
  }


  const AddFamilyHealthHistory = (item) => {
    if(!isViewAllowed) return;
    setFamilyHealthHistoryData(item)
    setIsOpenFamilyHealthHistory(prev => !prev);
  }
  const CloseFamilyHealthHistory = () => {
    setIsOpenFamilyHealthHistory(false)
  }

  let PopupScreen = "";
  if (isOpenFamilyHealthHistory) {
    PopupScreen = <AddNewFamilyHealthHistory isOpenFamilyHealthHistory={isOpenFamilyHealthHistory} familyHealthHistoryData={familyHealthHistoryData} setFamilyHealthHistoryData={setFamilyHealthHistoryData} setIsRecordSaved={setIsRecordSaved} onClose={CloseFamilyHealthHistory} patientID={patientID} // onDeleteFamilyHealthHistory={DeleteFamilyHealthHistory}  
    IsEditAllowed={IsEditAllowed} IsDeleteAllowed={IsDeleteAllowed}
    />
  }
  return (
    <>
      {PopupScreen}
      <div className='content-box px-0'>
        <div className='d-flex align-items-center justify-content-between br-bottom-1 ar-light pb-1 mb-1 mx-2'>
          <p className='cursor-pointer fs-13 heading user-select-none' onClick={handleToggleExpand}>Family Health History</p>
          <i class={`icon-dash-plus  ${isViewAllowed ? '' : 'disable'}`} onClick={() => AddFamilyHealthHistory({ PatientHistoryID: null })}></i>
        </div>
        <div className="d-flex flex-column gap-1 problem-scroll px-2">
          {expandItems &&
            expandAll &&
            (data &&
              data?.length > 0 ?
              data.map(item => (
                // <p className='text validate-color' onClick={() => AddDevelopmentHistory(item)}>{item.Notes}</p>
                <div className='ar-dot'>
                  <p className={`multiline-ellipsis  text ar-hover-text validation_message ${isViewAllowed ? '' : 'disable'}`} onClick={() => AddFamilyHealthHistory(item)}>{item.Notes}</p>
                  {/* <p className="text validate-color mb-2">Grand Mother</p>
              <p className="text">Liver Cancer(W34.M9)</p> */}
                </div>
              )) :
              <p className="text C9-light-clr fst-italic">No family health history recorded</p>)}
        </div>
      </div>
    </>
  )
}

export default FamilyHealthHistory